import { connect } from 'react-redux';
import Component from './Component';

const mapStateToProps = (state) => ({
  order: state.screens.OrderView.order,
})

const actionCreators = {};

export default connect(mapStateToProps, actionCreators)(Component);